/** Labels and tones of the integrations area (English source strings, marked with msg()). */
import { msg } from '@/lib/i18n';
import type { Tone } from '@/ui';
import type { DeliveryOut, DeliveryStatus, WebhookOut } from './types';

export type WebhookState = 'active' | 'failing' | 'disabled' | 'archived';

/** Active endpoints whose last deliveries failed are "failing" (they are not disabled yet). */
export function webhookState(w: Pick<WebhookOut, 'status' | 'consecutive_failures'>): WebhookState {
  if (w.status === 'active' && w.consecutive_failures > 0) return 'failing';
  return w.status;
}

export const WEBHOOK_STATES: Record<WebhookState, { label: string; tone: Tone }> = {
  active: { label: msg('Active'), tone: 'good' },
  failing: { label: msg('Failing'), tone: 'caution' },
  disabled: { label: msg('Disabled'), tone: 'neutral' },
  archived: { label: msg('Deleted'), tone: 'neutral' },
};

export const DELIVERY_STATES: Record<DeliveryStatus, { label: string; tone: Tone }> = {
  pending: { label: msg('Queued'), tone: 'info' },
  retrying: { label: msg('Retrying'), tone: 'caution' },
  delivered: { label: msg('Delivered'), tone: 'good' },
  failed: { label: msg('Failed'), tone: 'bad' },
  cancelled: { label: msg('Cancelled'), tone: 'neutral' },
};

export const SOURCES: Record<DeliveryOut['source'], string> = {
  event: msg('Subscription'),
  flow: msg('Flow step'),
  manual: msg('Sent by hand'),
  ping: msg('Test ping'),
};

export const canRetry = (d: Pick<DeliveryOut, 'status'>) => d.status === 'failed' || d.status === 'cancelled';

/** "tacho." → "tacho.*", "*" → every event. */
export function patternLabel(p: string): string {
  return p === '*' ? '*' : p.endsWith('.') ? `${p}*` : p;
}
